module.exports = __webpack_public_path__ + "static/media/Angie.d80288b7.jpg";